module.exports = __webpack_public_path__ + "static/media/Brienne of Tarth 2.902a9b42.jpg";